// This file is updated by the Telegram bot.
const AppConfig = {
    title: "جیهاز و ئەسیلە پۆلی12(مامەشێخ)",
    paragraph: "TikTok",
    img: "https://i.postimg.cc/GmZJfRWH/IMG-7725.jpg",
    url: "mama-shex",
    id: "5260926"
};

export default AppConfig;
